export default function AddUserIcon() {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 15.7717C7.4034 15.7717 7.30842 15.7469 7.22423 15.6995L1.03673 12.219C0.949737 12.1701 0.877333 12.0989 0.826945 12.0127C0.776557 11.9266 0.75 11.8286 0.75 11.7288V4.79297C0.75 4.69316 0.776557 4.59515 0.826945 4.50899C0.877333 4.42284 0.949737 4.35164 1.03673 4.30271L7.22423 0.822239C7.30842 0.774879 7.4034 0.75 7.5 0.75C7.5966 0.75 7.69158 0.774879 7.77577 0.822239L13.9633 4.30271C14.0503 4.35164 14.1227 4.42284 14.1731 4.50899C14.2234 4.59515 14.25 4.69316 14.25 4.79297V11.7288C14.25 11.8286 14.2234 11.9266 14.1731 12.0127C14.1227 12.0989 14.0503 12.1701 13.9633 12.219L7.77577 15.6995C7.69158 15.7469 7.5966 15.7717 7.5 15.7717ZM7.5 15.7717L7.56673 8.26087M14.1724 4.50801L7.56673 8.26087M7.56673 8.26087L0.827906 4.50738"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
